
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters("restaurant", ["offlineChannelCount"])
  },
  props: {
    classProp: {
      type: String,
      default: "py-md-4 mr-2 border-1 bg-white"
    }
  },

  methods: {
    handleMenuClick() {
      this.$emit("show-brands");
    }
  }
};
